import { message } from "antd";
import { token } from "../../constants/Constants";
import { fetch_all_tats } from "../../endpoints/API";

export const fetchTAT = async (setTAT, baseUrl, prodTestUrl) => {
  try {
    const response = await fetch_all_tats();
    if (response.statusText=="OK") {
      const data = response?.data;
      setTAT(data?.data);
    } else {
      message.error("Failed to fetch TAT(Turn Around Time).");
    }
  } catch (error) {
    message.error("An error occurred while fetching TAT(Turn Around Time).");
  }
};
